<template>
  <div class="outer-box max-w-xl">
    <h4>Get Twilio Phone Number Info</h4>

    <b-alert show variant="info" class="text-left m-3">
      Includes information on the Twilio SID, ISV mode, forwarding number, call recording status,
      and caller ID status.
    </b-alert>

    <div class="inner-box" style="text-align: left; width: 500px">
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Enter Phone number with country code"
        v-model="phoneNumber"
      />
      <button class="btn btn-primary mt-4" @click="fetchPhoneNumberInfo">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Fetch Phone Info </span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa; padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SpmAppengineService } from "@/services";

export default {
  data() {
    return {
      phoneNumber: "",
      processing: false,
      response: null,
    };
  },
  methods: {
    fetchPhoneNumberInfo() {
      this.processing = true;
      SpmAppengineService.getTwilioPhoneInfo({
        phoneNumber: this.phoneNumber,
      })
        .then((response) => {
          this.response = response.data;
        })
        .catch((error) => {
          this.response = error.response.data;
        })
        .finally(() => {
          this.processing = false;
        });
    },
  },
};
</script>

<style></style>
